import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';

export class AssetDA {
  static apiResponse: ApiResponse

  public static async getAssets(
    id_company: string,
    search: string = '',
    sort_field: string = '',
    sort_mode: string = '',
    page: number = 1,
    limit: number = 20,
    status: string = '',
    id_category: string = '',
    id_storage_center: string = ''
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/assets?search=${search}&sort_field=${sort_field}&sort_mode=${sort_mode}&page=${page}&limit=${limit}`
    if (status) url += `&status=${status}`
    if (id_category) url += `&id_category=${id_category}`
    if (id_storage_center) url += `&id_storage_center=${id_storage_center}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Unknown error',
        data: error.response?.data?.error ?? error.message
      }
    })

    return this.apiResponse
  }

  public static async getAsset(
    id_company: string,
    id_asset: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/assets/${id_asset}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Unknown error',
        data: error.response?.data?.error ?? error.message
      }
    })

    return this.apiResponse
  }

  public static async postAsset(
    id_company: string,
    data: any
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/assets`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, data, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Unknown error',
        data: error.response?.data?.error ?? error.message
      }
    })

    return this.apiResponse
  }

  public static async putAsset(
    id_company: string,
    id_asset: string,
    data: any
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/assets/${id_asset}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.put(url, data, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Unknown error',
        data: error.response?.data?.error ?? error.message
      }
    })

    return this.apiResponse
  }

  public static async deleteAsset(
    id_company: string,
    id_asset: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/assets/${id_asset}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.delete(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Unknown error',
        data: error.response?.data?.error ?? error.message
      }
    })

    return this.apiResponse
  }
}
